import { render, staticRenderFns } from "./StockOpnamePrintDetails.vue?vue&type=template&id=74c5fc64&"
import script from "./StockOpnamePrintDetails.vue?vue&type=script&lang=js&"
export * from "./StockOpnamePrintDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports